"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Search_module_1 = require("./modules/Search.module");
const loadMenuSearchModule = () => ({
    hasRouter: false,
    modules: [(0, Search_module_1.default)()],
});
exports.default = loadMenuSearchModule;
